import type { FindingCategory } from 'api/graphQL/types/specIntelligence.types'

/** Spec Intelligence brand gradient — purple-to-blue, used on AI action buttons. */
export const SPEC_INT_GRADIENT = 'linear-gradient(135deg, #5B2D8E 0%, #1565C0 100%)'

/** Darkened hover variant of {@link SPEC_INT_GRADIENT}. */
export const SPEC_INT_GRADIENT_HOVER = 'linear-gradient(135deg, #4a2275 0%, #0d47a1 100%)'

/** Accent color for AI-generated content (AI Recs tile, AI badge). */
export const SPEC_INT_AI_COLOR = '#6A0DAD'

/** Display label for the Cross-References finding category. */
export const CROSS_REFERENCES_LABEL = 'Cross-References'

/** Display label for the ErrorsAndOmissions finding category. */
export const OMISSION_LABEL = 'Errors & Omissions'

/** Display label for the Contradictions finding category. */
export const CONTRADICTION_LABEL = 'Contradictory Language'

/** Display label for the Coordination finding category. */
export const COORDINATION_LABEL = 'Coordination'

/** Maps each finding category to its display label. Single source of truth for both the finding-card chip and the category-selection pills. */
export const CATEGORY_DISPLAY_LABELS: Record<FindingCategory, string> = {
    CrossReferences: CROSS_REFERENCES_LABEL,
    ErrorsAndOmissions: OMISSION_LABEL,
    Contradictions: CONTRADICTION_LABEL,
    Coordination: COORDINATION_LABEL,
}

/** Maps each finding category to its chip background/text colors. Single source of truth for both the finding-card chip and the category-selection pills. */
export const CATEGORY_COLORS: Record<FindingCategory, { backgroundColor: string; color: string }> = {
    ErrorsAndOmissions: { backgroundColor: '#FFCDD2', color: '#B71C1C' },
    CrossReferences: { backgroundColor: '#FFF3E6', color: '#A84F15' },
    Contradictions: { backgroundColor: '#EDE7F6', color: '#4527A0' },
    Coordination: { backgroundColor: '#FFCC80', color: '#993B00' },
}

/** Section-selection count above which we warn the user their picker choice may exceed the AI token limit. */
export const MAX_RECOMMENDED_SECTIONS = 40

/** Warning shown in the picker when selection exceeds {@link MAX_RECOMMENDED_SECTIONS}. */
export const TOKEN_LIMIT_WARNING_MESSAGE =
    'Note: This selection may exceed the AI token limit. If you get an error, try selecting fewer sections.'
